import React, { Component } from 'react';
import { Table, Form, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { usersLoaded } from '../../actions';
import { InputGroup, Text } from '../../components';
import { checkLoggedIn, validateAccess } from '../../session';
import { typeActions, userActions } from '../../webapi';
import { CONST_STRINGS, ALLOW_REENABLE_USER } from '../../config';
import { isKiosk } from '../../helper';

class DisabledUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      sortColumn: 'displayName',
      sortDesc: false,
      startIndex: 0,
      endIndex: 100,
      users: [],
      search: '',
    };
  }

  UNSAFE_componentWillMount() {
    checkLoggedIn(this, this.props.auth);
  }

  componentDidMount() {
    if (!ALLOW_REENABLE_USER || !validateAccess(this.props.auth.site, 'disableUser', this.props.auth, true)) {
      this.props.history.push('/mastermenu');
    } else {
      this.getDisabledUsers();
      this.getSites();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEmpty(prevProps.users) && !_.isEqual(prevProps.users, this.props.users)) {
      this.getDisabledUsers();
    }
  }

  async getDisabledUsers() {
    try {
      this.setState({ loading: true });
      const users = await userActions.getDisabledUsersRecursive(this.props.auth.site, '', []);
      this.setState({ users });
    } catch (error) {
      console.log('getDisabledUsers error', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  getSites() {
    typeActions
      .getSites()
      .then((res) => {
        res.data.forEach((e) => {
          e.Title = e.siteName;
          e.Key = e.Id;
        });
        this.setState({
          sites: res.data,
        });
      })
      .catch((error) => {});
  }

  prevPage() {
    if (this.state.startIndex === 0) {
      return;
    }
    this.setState({
      startIndex: this.state.startIndex - 100,
      endIndex: Math.ceil(this.state.endIndex / 100) * 100 - 100,
    });
  }

  nextPage() {
    if (this.state.startIndex + 100 >= this.state.users.length) {
      return;
    }
    this.setState({
      startIndex: this.state.startIndex + 100,
      endIndex: Math.ceil(this.state.endIndex / 100) * 100 + 100,
    });
  }

  handleChange(event) {
    var stateChange = {
      startIndex: 0,
      endIndex: 100,
    };
    stateChange[event.target.getAttribute('id')] = event.target.value;
    this.setState(stateChange);
  }

  getTypeTitle(user) {
    const typeObject = _.find(this.props.userTypes, (t) => {
      return t.typeName === user.type && t.site === user.site;
    });
    if (typeObject) {
      return typeObject.displayName;
    }
    if (user.type) {
      if (user.type === 'FORMKIOSK') {
        return CONST_STRINGS.KIOSK_FORM_LOCKOUT;
      }
      if (user.type === 'SIGNINKIOSK') {
        return CONST_STRINGS.KIOSK_FORM_SIGNIN;
      }
      return user.type;
    }
    return '';
  }

  getPaginationText() {
    const source = this.state.users;
    return `${Math.min(this.state.startIndex + 1, source.length)}-${Math.min(this.state.endIndex, source.length)}/${source.length}`;
  }

  sortByCol(col) {
    if (this.state.sortColumn === col) {
      this.setState({
        sortDesc: !this.state.sortDesc,
      });
    } else {
      this.setState({
        sortColumn: col,
        sortDesc: false,
      });
    }
  }

  getBirthday(date, format = 'DD MMM YYYY') {
    if (_.isUndefined(date) || _.isEmpty(date)) return null;
    return moment(date, 'YYYY-MM-DD').format(format);
  }

  getFormattedDate(date, format = 'D MMM YYYY') {
    return date ? moment.utc(date).local().format(format) : '';
  }

  sortSource(source) {
    let result = _.sortBy(source, this.state.sortColumn);

    if (this.state.sortColumn === 'type') {
      result = _.sortBy(result, (user) => {
        return this.getTypeTitle(user);
      });
    }
    if (this.state.sortColumn === 'LastAppUse') {
      result = _.sortBy(result, (user) => {
        if (!user.LastAppUse) {
          return Number.MAX_SAFE_INTEGER;
        }
        return Number.MAX_SAFE_INTEGER - user.LastAppUse;
      });
    }

    if (this.state.sortDesc) {
      result.reverse();
    }

    if (!_.isEmpty(this.state.search)) {
      let lowSearch = this.state.search.toLowerCase();
      if (lowSearch.indexOf('04') === 0) {
        lowSearch = lowSearch.substring(1); // account for phone numbers stored in +61 format
      }
      result = _.filter(result, (ev, i) => {
        if (!ev.displayName) {
          return false;
        }
        const type = this.getTypeTitle(ev);
        if (!type) {
          return false;
        }
        return (
          ev.displayName.toLowerCase().indexOf(lowSearch) > -1 ||
          type.toLowerCase().indexOf(lowSearch) > -1 ||
          ev.Id.toLowerCase().indexOf(lowSearch) > -1 ||
          (!_.isEmpty(ev.email) && ev.email.toLowerCase().indexOf(lowSearch) > -1) ||
          (!_.isEmpty(ev.phoneNumber) && ev.phoneNumber.toLowerCase().indexOf(lowSearch) > -1)
        );
      });
    }

    return _.filter(result, (ev, i) => {
      return i >= this.state.startIndex && i < this.state.endIndex;
    });
  }

  renderUsers(source) {
    return source.map((user, index) => {
      if (user != null) {
        const editLink = `/usershub/${isKiosk(user.type) ? 'kiosk' : 'user'}/${encodeURIComponent(user.Id)}`;
        return (
          <tr key={index}>
            <td className="table-TitleColumn" style={{ paddingLeft: 16 }}>
              {validateAccess(this.props.auth.site, 'disableUser', this.props.auth) ? (
                <Link to={editLink}>{user.displayName}</Link>
              ) : (
                <span>{user.displayName}</span>
              )}
            </td>
            <td>{this.getTypeTitle(user)}</td>
            <td>{user.Id}</td>
            <td>{this.getFormattedDate(user.LastAppUse)}</td>
            <td className="table-options">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {validateAccess(this.props.auth.site, 'disableUser', this.props.auth) && (
                  <Link to={editLink}>
                    <FontAwesome style={{ fontSize: 20, padding: 5, marginLeft: 12, cursor: 'pointer' }} name="pencil" />
                  </Link>
                )}
              </div>
            </td>
          </tr>
        );
      }
      return null;
    });
  }

  renderSort(col) {
    if (col !== this.state.sortColumn) {
      return null;
    }
    return <FontAwesome style={{ marginLeft: 5 }} name={this.state.sortDesc ? 'chevron-up' : 'chevron-down'} />;
  }

  sortIsActive(col) {
    if (col !== this.state.sortColumn) {
      return '';
    }
    return ' table--columnActive';
  }

  renderView(source) {
    if (_.isEmpty(source)) {
      return this.renderEmpty();
    }
    return (
      <Table className="plussTable" striped bordered condensed hover style={{ minWidth: '100%' }}>
        <thead>
          <tr>
            <th
              className={`${this.sortIsActive('displayName')}`}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.sortByCol('displayName');
              }}
            >
              User name{this.renderSort('displayName')}
            </th>
            <th
              className={`${this.sortIsActive('type')}`}
              style={{ cursor: 'pointer', minWidth: 100 }}
              onClick={() => {
                this.sortByCol('type');
              }}
            >
              Type{this.renderSort('type')}
            </th>
            <th
              className={`${this.sortIsActive('Id')}`}
              style={{ cursor: 'pointer', minWidth: 100 }}
              onClick={() => {
                this.sortByCol('Id');
              }}
            >
              User ID{this.renderSort('Id')}
            </th>
            <th
              className={`${this.sortIsActive('LastAppUse')}`}
              style={{ cursor: 'pointer', minWidth: 100 }}
              onClick={() => {
                this.sortByCol('LastAppUse');
              }}
            >
              Last Activity in App{this.renderSort('LastAppUse')}
            </th>
            <th style={{ width: 70 }} />
          </tr>
        </thead>
        <tbody>
          {/* Render Current Visitors here! */}
          {this.renderUsers(source)}
        </tbody>
      </Table>
    );
  }

  renderEmpty() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 32 }}>
        <div className="emptyState" />
        <div className="marginTop-32" style={{ maxWidth: 500, textAlign: 'center' }}>
          <Text type="h3">There are no disabled users</Text>
        </div>
      </div>
    );
  }

  renderPagination(source, noSearch) {
    return (
      <Form>
        {!noSearch && (
          <Row className="show-grid">
            <Col xs={8}>
              <InputGroup
                id={`search`}
                type="text"
                placeholder="Search users"
                value={this.state.search}
                onChange={(e) => this.handleChange(e)}
                autoComplete={false}
              />
            </Col>
          </Row>
        )}
        {source.length !== 0 && (
          <Row className="show-grid">
            <Col xs={6} className="paginationContainer">
              <FontAwesome className="pagination__left" name="chevron-left" onClick={this.prevPage.bind(this)} />
              <p className="pagination__text">{this.getPaginationText()}</p>
              <FontAwesome className="pagination__right" name="chevron-right" onClick={this.nextPage.bind(this)} />
            </Col>
          </Row>
        )}
      </Form>
    );
  }

  render() {
    let source = this.state.users;
    const sourceLength = source.length;
    source = this.sortSource(source);

    return (
      <div style={{ minWidth: '100%' }}>
        {this.renderPagination(source)}
        {this.renderView(source)}
        {sourceLength > 100 && this.renderPagination(source, true)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, users } = state;
  return { auth, users };
};

export default connect(mapStateToProps, { usersLoaded })(withRouter(DisabledUsers));
